export default __webpack_public_path__ + "static/media/dollargeneral.34140c68.jpg";